import { FC, MouseEvent, useRef, useState } from "react";
import styled from "styled-components";

import useOnClickOutside from "@/hooks/useOnClickOutside";
import FiltersDropdown from "@/components/FilterDropdown";
import { FilterGroupBody } from "@/components/FilterDropdown/Parts";
import FilterRadioButton from "@/components/FilterDropdown/FilterRadioButton";
import { AssignTopicsStatus } from "@/utils/enums";
import FilterButton from "@/components/FilterDropdown/FilterButton";

const Holder = styled.div`
  position: relative;
`;

const StyledFilterGroupBody = styled(FilterGroupBody)`
  padding: 4px;
`;

const renderSortTitle = (filter: AssignTopicsStatus) => {
  switch (filter) {
    case AssignTopicsStatus.DEFAULT:
      return "All";
    case AssignTopicsStatus.ASSIGNED:
      return "Unconfirmed topics";
    case AssignTopicsStatus.CONFIRMED:
      return "Confirmed topics";
    default:
      return "All";
  }
};

interface Props {
  activeFilter: AssignTopicsStatus;
  setActiveFilter: React.Dispatch<React.SetStateAction<AssignTopicsStatus>>;
}

const AssignTopicsFilter: FC<Props> = ({ activeFilter, setActiveFilter }) => {
  const [showFilter, setShowFilter] = useState(false);

  const ref = useRef<HTMLDivElement>(null);
  useOnClickOutside(ref, () => setShowFilter(false));

  return (
    <Holder ref={ref}>
      <FilterButton
        onClick={(e: MouseEvent<HTMLButtonElement>) => {
          e.stopPropagation();
          setShowFilter(!showFilter);
        }}
        isActive={showFilter}
        filterApplied={activeFilter !== AssignTopicsStatus.DEFAULT}
      />
      {showFilter && (
        <FiltersDropdown onClose={() => setShowFilter(false)}>
          <StyledFilterGroupBody>
            <FilterRadioButton
              id={`periodRadio${AssignTopicsStatus.DEFAULT}`}
              value={AssignTopicsStatus.DEFAULT.toString()}
              checked={activeFilter === AssignTopicsStatus.DEFAULT}
              setValue={() => setActiveFilter(AssignTopicsStatus.DEFAULT)}
            >
              {renderSortTitle(AssignTopicsStatus.DEFAULT)}
            </FilterRadioButton>
            <FilterRadioButton
              id={`periodRadio${AssignTopicsStatus.CONFIRMED}`}
              value={AssignTopicsStatus.CONFIRMED.toString()}
              checked={activeFilter === AssignTopicsStatus.CONFIRMED}
              setValue={() => setActiveFilter(AssignTopicsStatus.CONFIRMED)}
            >
              {renderSortTitle(AssignTopicsStatus.CONFIRMED)}
            </FilterRadioButton>
            <FilterRadioButton
              id={`periodRadio${AssignTopicsStatus.ASSIGNED}`}
              value={AssignTopicsStatus.ASSIGNED.toString()}
              checked={activeFilter === AssignTopicsStatus.ASSIGNED}
              setValue={() => setActiveFilter(AssignTopicsStatus.ASSIGNED)}
            >
              {renderSortTitle(AssignTopicsStatus.ASSIGNED)}
            </FilterRadioButton>
          </StyledFilterGroupBody>
        </FiltersDropdown>
      )}
    </Holder>
  );
};

export default AssignTopicsFilter;
